import ChipProps from './type';

import Typography from '../Typography';
import Loader from '../Loader';
import Icon from '../Icon';
import { ChipWrapper } from './styled';

const Chip = ({ ...props }: ChipProps) => {
  const {
    color = '#FFF',
    label,
    loading,
    disabled,
    iconName,
    variant,
    loaderCustomColor,
    hideIcon,
    ...rest
  } = props;

  if (!label) {
    return (
      <ChipWrapper {...rest} disabled={disabled} variant={variant} label={label} color={color}>
        {loading ? (
          <Loader
            size={12}
            pointRadio="4px"
            // eslint-disable-next-line no-nested-ternary
            color={variant === 'dark' ? '#FFF' : loaderCustomColor ? color : null}
          />
        ) : (
          <Icon name={iconName ?? 'dotSpecial'} color={color} size="12px" />
        )}
      </ChipWrapper>
    );
  }

  return (
    <ChipWrapper {...rest} disabled={disabled} variant={variant} label={label} color={color}>
      {loading && (
        <Loader
          size={12}
          pointRadio="4px"
          // eslint-disable-next-line no-nested-ternary
          color={variant === 'dark' ? '#FFF' : loaderCustomColor ? color : null}
        />
      )}
      {!loading && !hideIcon && <Icon name={iconName ?? 'dotSpecial'} color={color} size="12px" />}

      <Typography fontSize={12} color={color} style={{ fontWeight: 400, lineHeight: 1.4 }}>
        {label}
      </Typography>

      {(!disabled || loading) && <Icon name="closeOutlined" color={color} size="12px" />}
    </ChipWrapper>
  );
};

Chip.defaultProps = {
  variant: 'dark',
  color: '#FFF',
  backgroundColor: '#1F89FF',
  iconPosition: 'left',
  disabled: false,
  loading: false,
};

export default Chip;
